import React, { useEffect } from "react";

import { Bar } from "react-chartjs-2";

const ChartComponent = ({
  chartLastWeekDateArray,
  chartDataPreviouseWeekArray,
  chartDataCurrentWeekArray,
  chartCurrentWeekDateArray,
}) => {
  const labelArray = [];
  useEffect(() => {});

  for (
    let index = 0;
    index <= Object.keys(chartLastWeekDateArray).length;
    index++
  ) {
    if (chartLastWeekDateArray[index]) {
      labelArray.push(chartLastWeekDateArray[index].day);
    }
  }

  let dataLastWeekArray = [];
  let dataCurrentWeekArray = [];
  for (
    let index = 0;
    index <= Object.keys(chartLastWeekDateArray).length;
    index++
  ) {
    if (chartLastWeekDateArray[index]) {
      let replace = chartLastWeekDateArray[index].date.replace("/", "-");
      let replaceAgain = replace.replace("/", "-");

      let filterLastWeekArray = chartDataPreviouseWeekArray.filter(
        (item) => item.datetime.split(" ")[0] == replaceAgain
      );
      if (Object.keys(filterLastWeekArray).length == 0) {
        dataLastWeekArray.push(0);
      } else {
        let countPoint = 0;
        for (let i = 0; i < Object.keys(filterLastWeekArray).length; i++) {
          countPoint = countPoint + filterLastWeekArray[i].score;
        }
        dataLastWeekArray.push(countPoint);
      }
    }
  }

  for (
    let index = 0;
    index <= Object.keys(chartCurrentWeekDateArray).length;
    index++
  ) {
    if (chartCurrentWeekDateArray[index]) {
      let replace = chartCurrentWeekDateArray[index].date.replace("/", "-");
      let replaceAgain = replace.replace("/", "-");

      let filterCurrentWeekArray = chartDataCurrentWeekArray.filter(
        (item) => item.datetime.split(" ")[0] == replaceAgain
      );
      if (Object.keys(filterCurrentWeekArray).length == 0) {
        dataCurrentWeekArray.push(0);
      } else {
        let countPoint = 0;
        for (let i = 0; i < Object.keys(filterCurrentWeekArray).length; i++) {
          countPoint = countPoint + filterCurrentWeekArray[i].score;
        }
        dataCurrentWeekArray.push(countPoint);
      }
    }
  }

  const data = {
    labels: labelArray,
    previousDate: {
      label: "هفته ی گذشته",
      dataSet: dataLastWeekArray,
    },
    currentDate: {
      label: "",
      dataSet: dataCurrentWeekArray,
    },
  };
  return (
    <>
      <div className="dekstop-chart d-none d-md-block">
        <Bar
          className=""
          pointstyle="star"
          data={{
            labels: data.labels,
            responsive: true,
            offset: true,
            datasets: [
              {
                label: "هفته گذشته",
                pointstyle: "rectRounded",
                backgroundColor: "#35b4bf",
                barThickness: 23,
                categoryPercentage: 1,
                data: data.previousDate.dataSet, //From API
              },
              {
                label: "هفته جاری",
                backgroundColor: "#f0b11a",
                barThickness: 23,
                categoryPercentage: 1,
                pointstyle: "triangle",
                data: data.currentDate.dataSet, //From API
              },
            ],
          }}
          height={220}
          options={{
            offsetGridLines: true,
            drawTicks: true,
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 10,
              },
            },
            legend: {
              display: true,
              position: "right",
              align: "start",
              labels: {
                usePointstyle: true,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    padding: 5,
                  },
                  gridLines: {
                    display: false,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: false,
                  gridLines: {
                    drawBorder: false,
                  },
                  ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 6,
                    padding: 0,
                    callback(n) {
                      if (n < 1e3) return n;
                      if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
                    },
                  },
                },
              ],
            },
          }}
        />
      </div>
      <div className="responsive-chart d-block d-md-none">
        <Bar
          className=""
          pointstyle="star"
          data={{
            labels: data.labels,
            responsive: true,
            offset: true,
            datasets: [
              {
                label: "هفته گذشته",
                pointstyle: "rectRounded",
                backgroundColor: "#35b4bf",
                barThickness: 12,
                categoryPercentage: 1,
                data: data.previousDate.dataSet, //From API
              },
              {
                label: "هفته جاری",
                backgroundColor: "#f0b11a",
                barThickness: 12,
                categoryPercentage: 1,
                pointstyle: "triangle",
                data: data.currentDate.dataSet, //From API
              },
            ],
          }}
          height={220}
          options={{
            offsetGridLines: true,
            drawTicks: true,
            layout: {
              padding: {
                top: 10,
                right: 10,
                bottom: 10,
              },
            },
            legend: {
              display: true,
              position: "right",
              align: "start",
              labels: {
                usePointstyle: true,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    padding: 5,
                  },
                  gridLines: {
                    display: false,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: false,
                  gridLines: {
                    drawBorder: false,
                  },
                  ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 6,
                    padding: 0,
                    callback(n) {
                      if (n < 1e3) return n;
                      if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
                    },
                  },
                },
              ],
            },
          }}
        />
      </div>
    </>
  );
};

export default React.memo(ChartComponent);
